import { render, staticRenderFns } from "./ColumnTemplate.vue?vue&type=template&id=216c3e4a&scoped=true"
import script from "./ColumnTemplate.vue?vue&type=script&lang=js"
export * from "./ColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c3e4a",
  null
  
)

export default component.exports